export default {
    "accident": {
        "msg": {
            "error_featureable": "Ocorreu um erro na obtenção da informação para o ponto selecionado"
        }
    },
}
